<template>
  <SmartLink
    class="item"
    :disabled="disabled"
    :active-class="activeClass"
    :exact-active-class="exactActiveClass"
    :url="url"
    :route="route"
    :target="target"
    :method="method"
    :event="event"
    :hash="hash"
  >
    <slot />
  </SmartLink>
</template>

<script>
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    activeClass: {
      type: String,
      default: 'router-link-active',
    },
    exactActiveClass: {
      type: String,
      default: 'router-link-exact-active',
    },
    url: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_self',
      validator(value) { return ['_blank', '_self', '_parent', '_top'].includes(value); },
    },
    method: {
      type: Function,
      default: null,
    },
    event: {
      type: String,
      default: null,
    },
    hash: {
      type: String,
      default: null,
    },
  },
  components: { SmartLink },
};
</script>

<style scoped lang="scss">
.item {
  font-family: 'Inter', sans-serif;
  background-color: rgba(255, 255, 255, 0.5);
  font-size: 16px;
  font-weight: 400;
  color: #313437;
  padding: 8px;
  border: 1px solid #FFFFFF;
  border-radius: 16px;
  backdrop-filter: blur(24px);
  transition: background-color 0.3s ease;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background-color: rgba(255, 255, 255, 0.7);
  }
}
</style>
